import React, { useState } from 'react';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const heroImages = [
    {
      src: "/PhenoLeap.png",
      alt: "人工智能产品研发"
    },
    {
      src: "/ShinyCellX.png",
      alt: "生物信息学数据分析"
    },
    {
      src: "/DNA.png",
      alt: "DNA序列分析"
    },
    {
      src: "/MOCRdb.png",
      alt: "数据可视化"
    },
    {
      src: "/Protein.png",
      alt: "蛋白结构分析"
    }
  ];

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? heroImages.length - 1 : prevIndex - 1
    );
  };

  const goToImage = (index) => {
    setCurrentImageIndex(index);
  };
  return (
    <section id="home" className="relative bg-gradient-to-br from-primary-50 to-blue-100 pt-20">
      <div className="container-max section-padding">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[600px]">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight">
                引领生物信息学
                <span className="text-primary-600 block">数据分析革命</span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                为科研机构、医院和制药企业提供专业的多组学数据分析、
                临床数据挖掘和创新软件解决方案
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                className="btn-primary"
                onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              >
                了解我们的服务
              </button>
              <button
                className="btn-secondary"
                onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
              >
                查看产品演示
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-gray-200">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600">50+</div>
                <div className="text-sm text-gray-600">项目完成</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600">10+</div>
                <div className="text-sm text-gray-600">合作机构</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600">100%</div>
                <div className="text-sm text-gray-600">客户满意度</div>
              </div>
            </div>
          </div>

          {/* Right Content - Hero Image Carousel */}
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-2xl p-4 transform rotate-3 hover:rotate-0 transition-transform duration-300">
              <div className="relative overflow-hidden rounded-xl">
                <img
                  src={heroImages[currentImageIndex].src}
                  alt={heroImages[currentImageIndex].alt}
                  className="w-full h-80 object-cover transition-opacity duration-500"
                />

                {/* Navigation Arrows */}
                <button
                  onClick={prevImage}
                  className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 rounded-full p-2 transition-all duration-200 shadow-lg"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>

                <button
                  onClick={nextImage}
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 rounded-full p-2 transition-all duration-200 shadow-lg"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>

                {/* Image Indicators */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {heroImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToImage(index)}
                      className={`w-3 h-3 rounded-full transition-all duration-200 ${index === currentImageIndex
                        ? 'bg-primary-600 scale-110'
                        : 'bg-white/60 hover:bg-white/80'
                        }`}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Image Description */}
            <div className="mt-4 text-center">
              <p className="text-sm text-gray-600 font-medium">
                {heroImages[currentImageIndex].alt}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;